<template>
  <div class="hotel">
    <div class="hotel-center">
      <h1><a href="https://goo.gl/maps/WJy6krm5gpMRoQKy9" target="_blank" title="Vis i Google Maps">Eikerapen Gjestegård</a></h1>
      <fp-block :img="imageEikerapen" left>
        <p>
          Ettersom bryllupsfesten foregår på Eikerapen Gjestegård (som for mange av dere er noen timer unna deres egne senger), er det kanskje like greit å leie seg inn på gjestegården? <br> <br>
          Eikerapen tilbyr enkeltrom, dobbeltrom, familierom (inntil 6 senger) og hytter (inntil 12 senger). <br> <br>
          Det er ski-anlegg i nærheten, og stort sett ganske mye snø! (Bare ikke nyttår 2018 😥) Dersom man sjekker inn på gjestegården får man 10 % avslag på dagspass! <br> <br>

          For å booke rom <a href="https://eikerapen-gjestegaard.no/overnatting-rom/" target="_blank" style="color: white">trykk her</a>.<br> Husk å evt. si at dere er gjester i bryllupet!
          
        </p>
      </fp-block>
      <br>
      <br>
      <h1><a href="https://goo.gl/maps/6pSp6GAcS2zuHnhA7" target="_blank" title="Vis i Google Maps">Undeland Misjonsgård</a></h1>
      <fp-block :img="imageUndeland" right>
        <p>
          En alternativ boplass er Undeland Misjonsgård, som ligger cirka 1 time unna Eikerapen og 45 minutter unna kirka. <br> <br>
          Utdatert prisliste og oversikt over sove-plasser <a href="http://www.undeland.com/?page_id=54" target="_blank" style="color: white">finnes her</a>. PS: Kalenderen stemmer kanskje ikke 100&nbsp;%.

          For å bestille, eller undersøke detaljer: <a href="mailto:post@undeland.com" target="_blank" style="color: white">post@undeland.com</a>
        </p>
      </fp-block>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      imageEikerapen: {
        src: 'https://i.imgur.com/v3axfmf.jpg',
        text: 'Lille-nyttårsaften 2018 var vi innom og sjekket forholdene, og gledet oss til festen!'
      },
      imageUndeland: {
        src: 'https://i.imgur.com/wdC9CAp.jpg',
        // text: 'Til og med i små innlandsbygder har de droner til å ta bilder av leirplassene sine!'
        text: 'Tidligere hevdet vi at dette bildet var tatt med drone, men vi er gjort oppmerksom på at dette ble tatt fra toppen av ei gran.'
      },
    }
  },
  computed: {

  },
  methods: {
    
  }  
}
</script>

<style lang="scss">
  .hotel {
    width: 100%;

    background-position: center;
    background-image: url("../assets/mountains.jpg");
    background-size: cover;
    background-attachment: fixed;

    text-align: center;

    & > .hotel-center {
      background-color: rgba(63, 63, 63, 0.76);
      width: 60vw;
      margin: auto;
      min-height: calc(100vh - 64px);
      & > h1, & > p {
        padding: 20px 15px;
      }
      @media screen and (max-width: 900px){
        width: 100%;
      }
    }
  }
</style>
